import { Dispatch } from 'react';
import { AuthLogout, UpdateSession } from './AuthActions';
import { APP_LOGIN_URL, APP_LOGOUT_URL } from '../config/getEnvironmentVars';
import OktaAuth, { SessionObject } from '@okta/okta-auth-js';
import { v4 as uuidV4 } from 'uuid';
import { AuthProps } from './AuthReducer';

export const SessionStates = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  MFA_REQUIRED: 'MFA_REQUIRED',
  MFA_ENROLL: 'MFA_ENROLL',
};

const handleRedirect = async (authClient: OktaAuth) => {
  try {
    await authClient.handleRedirect();
  } catch (e) {
    // log or display error details
    console.log(e);
  }
};

const generateToken = (authClient: OktaAuth) => {
  //@ts-ignore
  const queryParams = window.location.search;
  const params = new URLSearchParams(queryParams);

   authClient.token.getWithRedirect({
    state: btoa(
      JSON.stringify({
        ...Object.fromEntries(params.entries()),
        uuid: uuidV4(),
      }),
    ),
  });
};

export const authLogin = async (
  dispatch: Dispatch<any>,
  state: AuthProps,
  authClient: OktaAuth,
) => {
  const session = await getSession(authClient, state, dispatch);
  const sessionExists = isSessionActive(session);
  const isAuthenticated = await authClient.isAuthenticated();

  if (!sessionExists) {
    if (authClient.isLoginRedirect()) {
      handleRedirect(authClient);
    } else if (!isAuthenticated) {
      // Start the browser based oidc flow, then parse tokens from the redirect callback url
      await authClient.signInWithRedirect({
        authorizeUrl: APP_LOGIN_URL,
      });
    } else {
      // User is authenticated
      //   if (sessionExists) {
      //     if (state.user !== null && state.user !== undefined) {
      //       UpdateUser(dispatch);
      //     }
      //   } else {
      authLogout(dispatch, authClient);
      //   }
    }
  } else if (!isAuthenticated && sessionExists) {
    generateToken(authClient);
  }
};

export const authLogout = async (
  dispatch: Dispatch<any>,
  authClient: OktaAuth,
  logoutURL = APP_LOGOUT_URL,
) => {
  await authClient.signOut({
    postLogoutRedirectUri: logoutURL,
  });
  AuthLogout(dispatch);
};

export const refreshSession = (
  dispatch: Dispatch<any>,
  authClient: OktaAuth,
) => {
  authClient.session
    .refresh()
    .then((session) => {
      UpdateSession(dispatch, session as SessionObject);
    })
    .catch((err) => console.warn(err));
};

export const refreshToken = (authClient: OktaAuth) => {
  authClient.token
    .renewTokens()
    .then((newToken) => {
      authClient.tokenManager.setTokens(newToken);
    })
    .catch((error) => {
      console.warn(error);
    });
};

export const getSession = async (
  authClient: OktaAuth,
  state: AuthProps,
  dispatch: Dispatch<any>,
) => {
  if (state.session !== undefined && Object.keys(state.session).length > 1) {
    return state.session;
  } else {
    const session = await authClient.session.get();
    // Added if statement in case both saved and updated session are INVALID (not logged in)
    // also added shallowEqual check in reducer in case state updated take time to reflect and
    // meanwhile multiple dispatch events are fired.
    if (state.session?.status !== 'INVALID' && session.status !== 'INVALID') {
      UpdateSession(dispatch, session);
    }
    return session;
  }
};

export const isSessionActive = (session: SessionObject | undefined) => {
  return session?.status === SessionStates.ACTIVE;
};

export const isTokenValid = async (
  state: AuthProps,
  authClient: OktaAuth,
  dispatch: Dispatch<any>,
) => {
  try {
    const session = await getSession(authClient, state, dispatch);
    const sessionUser: any = await session?.user?.();

    if (
      state.user?.preferred_username &&
      sessionUser?.profile?.login &&
      state.user?.preferred_username !== sessionUser?.profile?.login
    ) {
      //user1 user2 & user@oa.com user2@oa.com
      //user1 user2 & user@oa.com user@oa.com
      authClient.tokenManager.clear();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      location.reload();
    }
  } catch (error) {
    //invalid session
    console.log(error);
  }
};
